module.exports = __webpack_public_path__ + "media/industry_tag_icon/biz_fitness-8966e7f1.png";